import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import CurrencyInput from '../../../../components/form/CurrencyInput'
import CheckBox from '../../../../components/form/CheckBox'
import AmountWarn from '../../AmountWarn'
import {
  setContentMatchingMaxBiddingAmount,
  setCustomContentMatchingMaxBiddingAmountYn,
} from '../adGroupSlice'
import { integerValue } from '../../../../utils'

const ContentMatchingMaxBiddingAmount = ({ error }) => {
  const dispatch = useDispatch()
  const {
    contentMatchingMaxBiddingAmount,
    customContentMatchingMaxBiddingAmountYn,
    maxBiddingAmount,
    beforeContentMatchingMaxBiddingAmount,
    beforeCustomContentMatchingMaxBiddingAmountYn,
    beforeMaxBiddingAmount,
  } = useSelector(state => state.ad.adGroup.form)
  const handleValueChange = useCallback(
    value => {
      dispatch(setContentMatchingMaxBiddingAmount(integerValue(value)))
    },
    [dispatch]
  )
  const handleCheckedChange = useCallback(
    checked => {
      dispatch(setCustomContentMatchingMaxBiddingAmountYn(checked ? 'N' : 'Y'))
    },
    [dispatch]
  )
  return (
    <div
      className={classNames('area_item', {
        error,
      })}>
      <strong className="subtit_box">
        콘텐츠 매체 입찰가
        <HelpTooltip>
          콘텐츠 매체 전용으로 입찰가를 설정할 수 있습니다.
        </HelpTooltip>
      </strong>
      <div className="cont_card">
        <div className="item_card">
          <div className="group_item">
            <CurrencyInput
              name="contentMatchingMaxBiddingAmount"
              disabled={customContentMatchingMaxBiddingAmountYn === 'N'}
              min={70}
              max={100000}
              step={10}
              maxLength={6}
              value={contentMatchingMaxBiddingAmount}
              error={error}
              onValueChange={handleValueChange}
            />
            <CheckBox
              label="미설정"
              name="customContentMatchingMaxBiddingAmountYn"
              tiaraAction="콘텐츠매체입찰가_미설정_클릭"
              checked={customContentMatchingMaxBiddingAmountYn === 'N'}
              onCheckedChange={handleCheckedChange}
            />
            {!(
              beforeCustomContentMatchingMaxBiddingAmountYn === 'N' &&
              customContentMatchingMaxBiddingAmountYn === 'N'
            ) && (
              <AmountWarn
                before={
                  beforeCustomContentMatchingMaxBiddingAmountYn === 'Y'
                    ? beforeContentMatchingMaxBiddingAmount
                    : beforeMaxBiddingAmount
                }
                after={
                  customContentMatchingMaxBiddingAmountYn === 'Y'
                    ? contentMatchingMaxBiddingAmount
                    : maxBiddingAmount
                }
                error={error}
              />
            )}
          </div>
          {error ? (
            <p className="txt_error">{error}</p>
          ) : (
            <p className="desc_item">
              콘텐츠 매체 입찰가는 최소 70원 ~ 최대 100,000원까지 10원 단위로
              설정할 수 있습니다.
              <br />
              콘텐츠 매체 입찰가를 설정하지 않을 경우 콘텐츠 매체 광고는 기본
              입찰가를 기준으로 입찰 합니다.
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
ContentMatchingMaxBiddingAmount.propTypes = {
  error: PropTypes.string,
}
export default ContentMatchingMaxBiddingAmount
